import { getSportCategoryId, normalizeSportId } from './sports';

export type ScoreChallengeVariantOption = {
  value: string;
  label: string;
  description: string;
};

const BASE_VARIANTS: Record<string, ScoreChallengeVariantOption[]> = {
  pinball: [{ value: 'high_score', label: 'High score', description: 'Post the best score.' }],
  weightlifting: [
    { value: 'one_rep_max', label: 'One Rep Max', description: 'Log the heaviest successful single.' },
    { value: 'max_reps', label: 'Max reps', description: 'Log the most reps at a chosen weight.' },
  ],
  crossfit: [
    { value: 'for_time', label: 'For time', description: 'Finish the workout as fast as possible.' },
    { value: 'amrap', label: 'AMRAP', description: 'Log as many rounds or reps as possible.' },
    { value: 'max_reps', label: 'Max reps', description: 'Log the most reps.' },
  ],
  hyrox: [
    { value: 'for_time', label: 'For time', description: 'Finish as fast as possible.' },
    { value: 'amrap', label: 'AMRAP', description: 'Log as many rounds or reps as possible.' },
  ],
  skateboarding: [
    { value: 'free_session', label: 'Open session', description: 'Log a solo line or session.' },
    { value: 'game_of_skate', label: 'Game of SKATE', description: 'Play letters head to head.' },
    { value: 'street_run', label: 'Street run', description: 'Score a street line.' },
  ],
  'bmx flatground': [
    { value: 'free_session', label: 'Open session', description: 'Log a solo line or session.' },
    { value: 'game_of_skate', label: 'Game of TRICKS', description: 'Play letters head to head.' },
    { value: 'street_run', label: 'Street run', description: 'Score a street line.' },
  ],
  scooter: [
    { value: 'free_session', label: 'Open session', description: 'Log a solo line or session.' },
    { value: 'game_of_skate', label: 'Game of SCOOT', description: 'Play letters head to head.' },
  ],
  'inline tricks': [
    { value: 'free_session', label: 'Open session', description: 'Log a solo line or session.' },
    { value: 'game_of_skate', label: 'Game of TRICKS', description: 'Play letters head to head.' },
  ],
};

export function isTrickStyleSport(sportId: string | null | undefined) {
  const normalized = normalizeSportId(sportId);
  return normalized ? getSportCategoryId(normalized) === 'trick-style' : false;
}

export function isGymSport(sportId: string | null | undefined) {
  const normalized = normalizeSportId(sportId);
  return normalized ? getSportCategoryId(normalized) === 'gym-performance' : false;
}

export function supportsScoreChallengeMode(sportId: string | null | undefined) {
  const normalized = normalizeSportId(sportId);
  return normalized ? Boolean(BASE_VARIANTS[normalized]) : false;
}

export function isScoreChallengeOnlySport(sportId: string | null | undefined) {
  return normalizeSportId(sportId) === 'pinball';
}

export function getScoreChallengeVariantOptions(sportId: string | null | undefined): ScoreChallengeVariantOption[] {
  const normalized = normalizeSportId(sportId);
  return normalized ? [...(BASE_VARIANTS[normalized] ?? [])] : [];
}

export function getTrickStyleVariantOptionsForPlayMode(
  sportId: string | null | undefined,
  mode: string,
): ScoreChallengeVariantOption[] {
  const options = getScoreChallengeVariantOptions(sportId);
  if (mode === 'score_challenge') return options.filter((option) => option.value !== 'game_of_skate');
  return options.filter((option) => option.value === 'game_of_skate' || option.value === 'free_session');
}

export function shouldShowGenericScoreChallengeSubtypePicker(sportId: string | null | undefined) {
  return getScoreChallengeVariantOptions(sportId).length > 1;
}
